import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTaskStatus } from '../api/tasks';
import { notification } from 'antd';

export function useUpdateTaskStatus(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: number }) =>
      updateTaskStatus(id, status),
    onSuccess: (_, { id }) => {
      notification.success({ message: 'Task status updated' });
      void queryClient.invalidateQueries({ queryKey: ['taskItems'] });
      void queryClient.invalidateQueries({ queryKey: ['taskItem', id] });
      void queryClient.invalidateQueries({ queryKey: ['task-dashboard'] });
      onSuccess?.();
    },
    onError: () => {
      notification.error({ message: 'Failed to update task status' });
    },
  });
}
